module.exports = {"500103001":"七星岗街道","500103003":"解放碑街道","500103004":"两路口街道","500103005":"上清寺街道","500103007":"菜园坝街道","500103008":"南纪门街道","500103010":"朝天门街道","500103011":"大溪沟街道","500103012":"大坪街道","500103013":"化龙桥街道","500103014":"石油路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500103.json
// module id = 2037
// module chunks = 0